module.exports = __webpack_public_path__ + "static/media/mwm_logo.0325ded1.jpg";